import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setInputsList } from '../../BusinessWorkOrderSystemSlice';
import RadioInput from 'app/Components/Shared/RadioInput/RadioInput';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Arrow from '../../Icons/openArrow.svg';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';

const PricePlanRadioInput = ({
  input,
  setInputsList,
  isLoading = false ,
  paramDesc,
  maxLength = 40
}) => {
  const [expandedPricePlanOptions, setExpandedPricePlanOptions] = useState({});


  const handleOptionToggle = (optionKey) => {
    setExpandedPricePlanOptions(prev => ({
      ...prev,
      [optionKey]: !prev[optionKey]
    }));
  };


  const truncateAtWordBoundary = (text) => {
    if (text.length <= maxLength) {
      return text;
    }
      const lastSpaceIndex = text.lastIndexOf(' ', maxLength);
      if (lastSpaceIndex !== -1) {
        return text.substring(0, lastSpaceIndex);
      }
     return text.substring(0, maxLength);
  };

  const handleOptionSelect = (optionValue) => {
    setInputsList({ 
      paramcode: input.paramCode, 
      value: optionValue, 
      error: '' 
    });
  };

  if (isLoading) {
    return <Skeleton count={4} height={40} />;
  }

  if (isNullOrEmpty(input.dropdownOptions)) {
    return null;
  }

  return (
    <div className='radio-input-container'>
      <div className='title'>{paramDesc}</div>
      {input.dropdownOptions.map((option, index) => {
        const isExpanded = expandedPricePlanOptions[option.option_key] || false;
        const valueToShow = option.option_value;
        const shouldTruncate = valueToShow.length > maxLength;
        const isSelected = input.value === option.option_key;

        return (
          <div 
            className={`price-plan-radio-row ${isExpanded ? 'expanded' : ''} ${isSelected ? 'selected' : ''}`} 
            key={option.option_key}
          >
            <RadioInput
              checked={isSelected}
              id={option.option_key}
              name={input.paramCode}
              value={option.option_value}
              label={
                <>
                  <div
                    className={`price-plan-ellipsis${shouldTruncate && !isExpanded ? ' truncated' : ''}`}
                    title={valueToShow}
                  >
                    {shouldTruncate && !isExpanded
                      ? truncateAtWordBoundary(valueToShow) + '...'
                      : valueToShow}
                 </div>
                {shouldTruncate && (
                <Image className={`price-plan-expand-btn ${isExpanded ? 'expanded' : ''}`}
                   onClick={() => handleOptionToggle(option.option_key)}
                   src={Arrow}
                   alt={isExpanded ? "סגור" : "פתח"} />)}
                </>
              }
              onChange={() => handleOptionSelect(option.option_key)}
            />

          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  // Add any state you need here
});

const mapDispatchToProps = {
  setInputsList
};

export default connect(mapStateToProps, mapDispatchToProps)(PricePlanRadioInput);